// extracted by mini-css-extract-plugin
export var lessonResourceItem = "LessonResourceItem-module--lessonResourceItem--Iw2cw";